module.exports = __webpack_public_path__ + "static/media/HMVpopupHeader.b516adac.svg";